<template>
  <div class="characteristic-properties">
    <div>
      <div v-if="this.bObject.TYPE == this.types.IMAGE">
        <div class="vspace"></div>
        <div class="left-align">
            <div class="pitem left right small-width-4 inline">Image</div> 
            <img class="pitem left right" :src="imgSrc" height="50px">
        </div>
      </div>
      
      <div v-if="this.bObject.TYPE == this.types.TEXT">
        <div class="vspace"></div>
        <div class="left-align">
            <div class="pitem left right small-width-6">Text</div> 
            <at-textarea v-model="text" class="left right" min-rows="2" max-rows="10" placeholder="Enter text here..."></at-textarea> 
        </div>
        <div class="vspace"></div>
        <div class="left-align">
            <div class="pitem left right small-width-6 inline">Font Size</div> 
            <at-input v-model="textSize" class="pitem small-width-10 inline" size="small"></at-input>
        </div>
      </div>

      <div v-if="this.isColourable()">
        <div class="vspace"></div>
        <div class="left-align">
            <div class="pitem left right small-width-6 inline">Fill</div>
            <at-checkbox class="pitem left right inline" v-model="doFill" label="Fill"></at-checkbox> 
            <b-color-picker class="pitem left right inline" v-bind:setColor="fillColor" v-on:input="userSelectedFillColor" />
        </div>

        <div class="vspace"></div>

        <div class="left-align">
          <div class="pitem left right small-width-6 inline">Stroke</div>
          <at-checkbox class="pitem left right inline" v-model="doStroke" label="Stroke"></at-checkbox>
          <b-color-picker class="pitem left right inline" v-bind:setColor="strokeColor" v-on:input="userSelectedStrokeColor" />
        </div>
        
      </div>
      
      <div v-if="this.bObject.TYPE == this.types.CIRCLE || this.bObject.TYPE == this.types.RECT || this.bObject.TYPE == this.types.VECTOR">
        <div class="vspace"></div>
        <div class="left-align">
            <div class="pitem left right small-width-8 inline">Line Width</div> 
            <at-input v-model="lineWidth" class="pitem small-width-10 inline" size="small"></at-input>
        </div>
      </div>

      <div v-if="this.bObject.TYPE == this.types.RECT || this.bObject.TYPE == this.types.VECTOR">
        <div class="vspace"></div>

        <div class="left-align">
            <div class="pitem left right small-width-8 inline">Joint</div> 
            <at-select v-model="jointType" style="width:100px">
                <at-option v-for="(item, index) in this.bObject.lineJoinVals" v-bind:key="index" :value="index">{{item}}</at-option>
            </at-select>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';
import { BMotionType } from '../../lib/bezieLib/Animations/BMotionEnums';
import { Scene } from '../../lib/bezieLib/Scene';
import { ObjectType } from '../../lib/bezieLib/Objects/ObjectTypeEnum';
import BColorPicker from '../utils/BColorPicker.vue';
import { ColourIndex, ColouringMode } from '../../lib/bezieLib/Colour/Colourable';
import { Colour } from '../../lib/bezieLib/Colour/Colour';

export default {
  name: 'CharacteristicProperties',
  components: {
    'b-color-picker': BColorPicker
  },
  props: {
    bObject : BObject, 
    bScene : Scene
  },
  data: function(){
    return {
        text: "", //Text Obj
        textSize: 40, //Text
        fillColor: '', //Shape, Text
        strokeColor: '', //Shape, Text
        doStroke: false,
        doFill: true,
        lineWidth: 2, //Shape
        jointType: "0", //Shape
        imgSrc: "", //Image
        types: ObjectType
    }
  },
  watch: {
    lineWidth : function(val){
      if(this.bObject){
        this.bObject.lineWidth = this.lineWidth;
      }
    },
    jointType: function(val){
        if(this.bObject){
            this.bObject.joinIndex = Number(this.jointType);
        }
    },
    text: function(str){
        if(this.bObject){
            this.bObject.text = this.text;
        }
    },
    textSize: function(val){
        if(this.bObject){
            this.bObject.size = this.textSize;
        }
    },
    doStroke: function(){
      this.setColouringMode();
    },
    doFill: function(){
      this.setColouringMode();
    },
    bObject: function(obj){
        this.init();
    }
  },
  methods:{
    userSelectedFillColor: function(val){
      console.log("userSelectedFillColor: "+val.hsv.h+";"+val.hsv.s+";"+val.hsv.v);
      if(this.bObject){
        this.bObject.setColour(ColourIndex.Fill, new Colour({h:val.hsv.h, s:val.hsv.s, v:val.hsv.v}));
      }
    },
    userSelectedStrokeColor: function(val){
      console.log("userSelectedStrokeColor: "+val.hsv.h+";"+val.hsv.s+";"+val.hsv.v);
      if(this.bObject){
        this.bObject.setColour(ColourIndex.Stroke, new Colour({h:val.hsv.h, s:val.hsv.s, v:val.hsv.v}));
      }
    },
    setColouringMode: function(){
      var mode = ColouringMode.None;
      if(this.doStroke && this.doFill){
        mode = ColouringMode.FillAndStroke;
      }else if(this.doStroke){
        mode = ColouringMode.Stroke;
      }else if(this.doFill){
        mode = ColouringMode.Fill;
      }
      if(this.bObject){
        this.bObject.setColouringMode(mode);
      }
    },
    isColourable: function(){
      return this.bObject.isColourable();
    },
    onUpdate : function(obj){
        if(obj) {
            this.init();
        }
    },
    init: function(){
        if(this.bObject){
          if(this.bObject.isColourable()){
            this.fillColor = this.bObject.getColour(ColourIndex.Fill);
            this.strokeColor = this.bObject.getColour(ColourIndex.Stroke);
            switch(this.bObject.getColouringMode()){
              case ColouringMode.None:
                this.doFill = false;
                this.doStroke = false;
                break;
              case ColouringMode.Fill:
                this.doFill = true;
                this.doStroke = false;
                break;
              case ColouringMode.Stroke:
                this.doFill = false;
                this.doStroke = true;
                break;
              case ColouringMode.FillAndStroke:
                this.doFill = true;
                this.doStroke = true;
                break;
            }
          }

          if(this.bObject.TYPE == ObjectType.CIRCLE || this.bObject.TYPE == ObjectType.RECT || this.bObject.TYPE == ObjectType.VECTOR){
            this.lineWidth = this.bObject.lineWidth;
            this.jointType = this.bObject.joinIndex;        
          }
          
          if(this.bObject.TYPE == ObjectType.TEXT){
            this.text = this.bObject.text;
            this.textSize = this.bObject.size;        
          }
          
          if(this.bObject.TYPE == ObjectType.IMAGE){
            this.imgSrc = this.bObject.img.src;
          }
        }
    }
  },
  mounted: function(){
      if(this.bObject){
        this.init();
        UIUpdate.addObjectUpdateListener(this);
      } 
  },
  beforeDestroy: function(){
    if(this.bObject){
      UIUpdate.removeObjectUpdateListener(this);
    }
  }
}
</script>

<style>
.heading{
  font-size: 20px;
}

.is-changeable-text{
  cursor: text;
}

.section{
  font-size: 16px;
}

.inline{
  display: inline-block;
}

.left-align{
    text-align: left;
}

.right-align{
    text-align: right;
}

.pitem{
  vertical-align: middle;
}

.vspace{
  height: 8px;
  width: 100%;
}

.vspace-2{
  height: 4px;
  width: 100%;
}

.left{
  margin-left: 10px;
}

.more-left{
  margin-left: 20px;
}

.right{
  margin-right: 10px;
}

.full-width{
    width: 100%;
}

.is-std-width{
  width: 140px;
}

.is-std-width-2{
  width: 120px;
}

.is-std-width-4{
  width: 80px;
}

.small-width-2{
  width: 20px;
}

.small-width-4{
  width: 40px;
}

.small-width-6{
  width: 60px;
}

.small-width-8{
  width: 80px;
}

.small-width-10{
  width: 100px;
}

.clickable{
  cursor: pointer;
}

</style>